export const NOTIFICATION_CREATED = 'notification-created';

export const NOTIFICATION_HIDDEN = 'notification-hidden';
